// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"d2aaa52b","355":"f98c4dbc","383":"d2aaa52b","566":"0f454b35","583":"d2aaa52b","631":"050b1ac5","872":"4e4636ad","936":"ee0773dd"}[chunkId] + ".chunk.css";
};